import { useEffect } from 'react';

export const useInterval = ({ action, timer, initOnStart }) => {
    let interval;
    useEffect(() => {
        initOnStart && initInterval();

        return clearInterval;
    }, []);

    const clearInterval = () => {
        window.clearInterval(interval);
        interval = null;
    };

    const initInterval = () => {
        interval = setInterval(action, timer);
    };

    return {
        interval,
        clearInterval,
        initInterval
    };
};
